import React from "react";
import { Cognito } from "./Cognito";

export type CognitoContextValue = {
  cognito: Cognito;
  isLoggedIn: boolean;
};

export const CognitoContext = React.createContext<CognitoContextValue>(null!);
